import React, { PureComponent, Fragment } from "react";
import { PropTypes } from "prop-types";
import { Message, Icon, Transition } from "semantic-ui-react";
import LinkWithReset from "../../utils/LinkWithReset.jsx";

class SegmentMessage extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    actionLabel: PropTypes.string,
    actionURL: PropTypes.string,
    icon: PropTypes.string,
    negative: PropTypes.bool.isRequired,
    positive: PropTypes.bool.isRequired,
    warning: PropTypes.bool.isRequired,
    info: PropTypes.bool.isRequired,
    color: PropTypes.string,
    iconColor: PropTypes.string,
    dismissable: PropTypes.bool.isRequired,
    timed: PropTypes.bool.isRequired,
    time: PropTypes.number,
    duration: PropTypes.number
  };

  static defaultProps = {
    negative: false,
    positive: false,
    warning: false,
    info: false,
    dismissable: false,
    timed: false,
    time: 2000,
    duration: 500,
    data: {}
  };

  constructor(props) {
    super(props);

    this.hideTimeout = null;

    this.state = {
      visible: false,
      hideTimeout: null
    };
  }

  // -- TIMED MESSAGE -- //

  componentDidMount() {
    const { timed, time } = this.props;
    if (timed === true) {
      this.hideTimeout = setTimeout(this.hideMessage, time);
    }
    this.setState({ visible: true });
  }

  componentWillUnmount() {
    clearTimeout(this.hideTimeout);
  }

  hideMessage = () => {
    this.setState({ visible: false });
  };

  // -- RENDER -- //

  getIcon = () => {
    const { icon, negative, positive, warning, info } = this.props;

    if (icon) return icon;
    if (positive) return "check circle";
    if (negative || warning || info) return "exclamation circle";

    return "bug";
  };

  renderMessage = () => {
    const {
      title,
      message,
      actionLabel,
      actionURL,
      dismissable,
      negative,
      positive,
      warning,
      info,
      color,
      iconColor,
      attached,
      className,
      children,
      style
    } = this.props;

    const fullClassName = className
      ? `segment-message ${className}`
      : "segment-message";

    return (
      <Message
        color={color}
        negative={negative}
        positive={positive}
        warning={warning}
        info={info}
        onDismiss={dismissable ? this.hideMessage : null}
        attached={attached}
        icon
        size="small"
        className={fullClassName}
        style={style}
      >
        <Icon name={this.getIcon()} color={iconColor} />
        <Message.Content>
          <Message.Header>{title}</Message.Header>
          {message && <p>{message}</p>}
          {actionLabel && actionURL && (
            <Fragment>
              <LinkWithReset to={actionURL}>{actionLabel}</LinkWithReset>{" "}
              <Icon name="chevron circle right" />
            </Fragment>
          )}
        </Message.Content>
        {children}
      </Message>
    );
  };

  render() {
    const { timed, duration } = this.props;
    const { visible } = this.state;

    if (timed === true) {
      return (
        <Transition visible={visible} animation="fade" duration={duration}>
          {this.renderMessage()}
        </Transition>
      );
    }

    if (visible) return this.renderMessage();

    return null;
  }
}

export default SegmentMessage;
